import { useEffect, useState } from "react";
import UserForm from "./Components/UserForm";
import api from "../../utils/axios"

const NewUser = () => {
  
	// Buscador de categorías de varios
	const [categoriesFound, setCategoriesFound] = useState([])

  useEffect(() => {
		;(async () => {
			try {
				const response = await api.get("/categories")
				setCategoriesFound(response.data.categories)
			} catch (error) {
        console.log(error)
      }
		})()
	}, [])

  return <UserForm type="createUser" categoriesFound={categoriesFound}/>
};

export default NewUser;
